<template>
  <legal-document-view :slug="slug" />
</template>

<script setup lang="ts">
/**
 * Юридические документы, кроме политики конфиденциальности: согласие на
 * обработку персональных данных, пользовательское соглашение, правила
 * пользования Личным Кабинетом и прочие.
 *
 * Политика живёт отдельной страницей на верхнем уровне (/privacy-policy),
 * потому что этот адрес проиндексирован и на него ссылаются извне.
 */
const route = useRoute()
const slug = computed(() => String(route.params.slug ?? ''))
</script>
